import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import ar from './locales/ar/translation.json';
import en from './locales/en/translation.json';

i18n.use(initReactI18next).init({
  resources: {
    ar: { translation: ar },
    en: { translation: en }
  },
  lng: localStorage.getItem('lang') || 'ar',
  fallbackLng: 'en',
  interpolation: { escapeValue: false },
  showSupportNotice: false,
});

export default i18n;
